import React from "react";
import { Container, Col, Row, Input, Button } from "reactstrap";

import Header from '../Component/Header';
import Footer from '../Component/Footer';

const Investors = () => {
  return (
    <div id="investor" className="investor-container">
      <Header investor={true} />

      <Container>
        <p className="text-header">History</p>
        <Row className="row-content">
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history1.jpg')} />
          </Col>
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              As open-source software became available to support building of advanced self-learning systems, we saw the opportunity to develop a platform using machine learning to accelerate quality application development.
              </p>
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              iRithm started as a R&D project on program synthesis and alternative programming languages representations during 2017. As the research continued, the product matured into a platform for application development for mobile, web and desktop.
              </p>
          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history2.jpg')} />
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history3.jpg')} />
          </Col>
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              Based on solid theoretical foundation in programming languages design and machine learning and years of efforts, our programming language iRExt is a transpiled declarative language that supports virtual actor model and machine learning algorithms weaved to the language.
              </p>
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              As the platform evolved and got smarter –  we realized that this solution was delivering not only a platform but an essential resource to help businesses build solutions faster.
              </p>
          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history4.jpg')} />
          </Col>
        </Row>

        <p style={{ textAlign: 'center' }} className="history-text">
          So, iRithm, the AI assistant for application development, enhanced by machine-learning, was born.
        </p>

        <p className="text-header">Roadmap</p>
        <div className='roadmap-container'>
          <img src={require('../_assets/image/history/roadmap.jpg')} />
        </div>

        <p className="title-investment">
          Investment Required
        </p>

        <Row className="row-content">
          <Col className="text-clm-list" lg={6} md={12} sm={12}>
            <ul>
              <li>Speedup public release</li>
              <li>Sales</li>
              <li>Marketing</li>
              <li>Increase the team size</li>
              <li>Build support capabilities</li>
              <li>Increase the feature of the system</li>
              <li>Support AWS and Azure</li>
            </ul>
          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='img-invest' src={require('../_assets/image/history/invest.jpg')} />
          </Col>
        </Row>

        <Row className="row-content">
        <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='img-invest' src={require('../_assets/image/history/edit.jpg')} />
          </Col>
          <Col className="text-clm-list" lg={6} md={12} sm={12}>
            <ul>
              <li>Support opensource database</li>
              <li>Scalability of the infrastructure to be able to support more users.</li>
              <li>Data cleansing for machine learning training</li>
              <li>Machine learning servers for training</li>
              <li>Tutorials and documentation</li>
              <li>Increase the feature of the system</li>
              <li>Better chatbot response</li>
            </ul>
          </Col>
        </Row>

        <Container style={{ marginBottom: 60 }} className="section-touch">
        <Col lg={6}>
          <p className="feature-title">
          Get in Touch With Us
          </p>
          <Input
            type="name"
            name="name"
            className="input"
            placeholder="your goodname"
          />
          <Input
            type="email"
            name="email"
            className="input2"
            placeholder="email address"
          />
          <Input
          type="textarea"
            className="input3"
            placeholder="Comment"
          />
          <Button className="btn-join" color="primary">Submit</Button>
        </Col>
      </Container> 
      </Container>
      <Footer />
    </div>
  );
}

export default Investors;